import { Grid } from "@mui/material"
import React from "react"
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid"
import { WSTabs } from "../../Components/Tabs/WSTabs";

export const AllOrderSummary:React.FC<any>=React.memo((props)=>{
    const columns: IColumns[] = [
       
        {
          header: "Order",
          fieldName: "",
          tooltip: true,
          type: "link",
        },
        {
          header: "Time",
          fieldName: "",
          tooltip: true,
        },
        {
            header: "Receipt No",
            fieldName: "",
            tooltip: true,
        },
        {
            header: "R/T No",
            fieldName: "",
            tooltip: true,
        },
        {
            header: "Order Type",
            fieldName: "",
            tooltip: true,
        },
        {
            header: "Guest Name",
            fieldName: "",
            tooltip: true,
        },
        {
            header: "user",
            fieldName: "",
            tooltip: true,
        },
        {
            header: "Status",
            fieldName: "",
            tooltip: true,
        },
        {
          header: "Actions",
          fieldName: "actions",
          type: "action",
          actions: ["Edit"],
        },
      ];
    return(
<div >
        <Grid container >
          <Grid item xs={12}>
            <WSDataGrid
              id="ordersummarygrid"
              // title="Order Summary"
              columns={columns}
            />
          </Grid>
        </Grid>
      
    </div>
    )
})